/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q9Inputs */

const en_fc_home_faq_q9 = /** @type {(inputs: Fc_Home_Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does FilmCraft have AI features?`)
};

/**
* | output |
* | --- |
* | "Does FilmCraft have AI features?" |
*
* @param {Fc_Home_Faq_Q9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q9 = /** @type {((inputs?: Fc_Home_Faq_Q9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q9(inputs)
});
export { fc_home_faq_q9 as "fc.home.faq.q9" }